/**
 * Module: utilities
 * General helper functions
 *
 * @package mindgrub-starter-theme
 */


/**
 * Determine if a given string is a valid email address
 *
 * {@link https://html.spec.whatwg.org/multipage/input.html#email-state-(type=email) Reference}
 */
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

/**
 * Determine if a given string is a valid email address
 *
 * @param  {string} email The email address
 * @return {bool}
 */
var isEmail = function( email ) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test( email );
}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

const form = {
	isProcessing: false,
	addErrorStatus: ($el, message = 'Invalid Input') => {
        $el.addClass('error');
        if (!$el.siblings('.input__message.error').length) {
            $el.after('<p class="input__message error">' + message + '</p>');
        }
	},
	prepareRequest: (selector, data) => {
		let validated = true;
		$(selector).each(function(i, el) {
			if(form.validateInput(i, $(el))) {
				data[$(el).attr('id')] = $(el).val();
			}
			else {
				form.addErrorStatus($(el));
				validated = false;
			}
		});
		return validated;
	},
	handleSubmit: (e, cb) => {
        if (e.keyCode && e.keyCode === 13 && e.target.className.indexOf('btn') !== 0) {
			e.stopPropagation();
			e.preventDefault();
            cb();
        }
    },
	togglePassword: ($inputs) => {
        const $passwords = $inputs.filter('.input--password');
        $passwords.attr('type', $passwords.attr('type') === 'password' ? 'text' : 'password');
    },
	validateInput: function(e, $el, $fields) {
        if ($el.attr('type') === 'email' && !$el.val().match(EMAIL_REGEX)) {
            this.addErrorStatus($el, 'Email is invalid.');
        }
        else if ($el.hasClass('password-change') && !this.validatePassword(e, $el[0])) {
			console.log('password invalid');
            this.addErrorStatus($el, 'Password is invalid.');
        }
        else if ($el.attr('id') === 'password_confirm' && $fields && $el.val() !== $fields.filter('.password-change').val()) {
			console.log('password dint match');
            this.addErrorStatus($el, 'Passwords must match.');
        }
        else if (!$el.val() && $el.attr('required')) {
			console.log('required');
            this.addErrorStatus($el, $el.siblings('.input__label').text() + ' is required.');
        } else {
            $el.siblings('.input__message.error').remove();
			$el.removeClass('error');
			return true;
        }
    },
	validatePassword: function(e, el) {
        let passwordValid = true;
        el = e.target ? e.target : el;

        $.each(this.passwordRules, function(key, item) {
            if($(el).val().match(item.rule)) {
                item.$sel.addClass('okay').find('.icon').removeClass('icon-x-circle').addClass('icon-check-circle');
            } else {
                passwordValid = false;
                item.$sel.removeClass('okay').find('.icon').removeClass('icon-check-circle').addClass('icon-x-circle');
            }
        });
		console.log('pass valid?', passwordValid);

        return passwordValid;
    },
	$passwordValidation: $('.dialogue--password').find('.dialogue__list--item')
};
form.passwordRules = {
	minchars: {
		'$sel': form.$passwordValidation.filter('#password--minchars'),
		'rule': /^.{8,}$/,
	},
	uppercase: {
		'$sel': form.$passwordValidation.filter('#password--uppercase'),
		'rule': /[A-Z\s]+/,
	},
	lowercase: {
		'$sel': form.$passwordValidation.filter('#password--lowercase'),
		'rule': /[a-z\s]+/,
	},
	number: {
		'$sel': form.$passwordValidation.filter('#password--number'),
		'rule': /[0-9\s]+/,
	},
	special: {
		'$sel': form.$passwordValidation.filter('#password--special'),
		'rule': /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
	}
};

/**
 * Public API
 */
module.exports = {
	isEmail : isEmail,
	debounce : debounce,
	form: form
};



// WEBPACK FOOTER //
// ./scripts/components/utilities.js